import { render, staticRenderFns } from "./TreatmentPlan.vue?vue&type=template&id=6408a525"
import script from "./TreatmentPlan.vue?vue&type=script&lang=js"
export * from "./TreatmentPlan.vue?vue&type=script&lang=js"
import style0 from "./TreatmentPlan.vue?vue&type=style&index=0&id=6408a525&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports